import { ShieldCheck } from 'lucide-react';
import { BrandHeader } from '../components/BrandHeader';
import { InstallPrompt } from '../components/InstallPrompt';
import { LoginForm } from '../components/LoginForm';
import type { Username } from '../utils/constants';

type LoginPageProps = {
  authError?: string;
  onLogin: (username: Username, password: string) => Promise<void>;
};

export function LoginPage({ authError, onLogin }: LoginPageProps) {
  return (
    <main className="app-shell auth-shell">
      <section className="hero-panel auth-panel" aria-labelledby="login-title">
        <BrandHeader action={<InstallPrompt />} />
        <div className="auth-copy">
          <span className="permission-icon success">
            <ShieldCheck size={24} aria-hidden="true" />
          </span>
          <div>
            <p className="panel-kicker">Two trusted users</p>
            <h2 id="login-title">Private emergency access</h2>
            <p>No signup, no external auth, no third-party database. Sessions are stored in Cloudflare KV.</p>
          </div>
        </div>
        <LoginForm authError={authError} onLogin={onLogin} />
        <aside className="safety-note">
          <ShieldCheck size={18} aria-hidden="true" />
          <p>The shared password is checked only by the Cloudflare backend.</p>
        </aside>
      </section>
    </main>
  );
}
